export const PageButtons = {
  dashboard: ['create-promotion', 'add-store', 'recharge-account'],
  stores: ['create-promotion', 'add-store', 'initial-promotion'],
  'store-groups': ['create-store-group'],
  promotions: ['create-promotion'],
  'store-managers': ['add-store-manager'],
  'payment-history': ['recharge-account'],
  statements: [''],
};
